import {
    Grid,
    GridProps,
} from '@chakra-ui/react';
import { OutdoorBarArticlePortionModel } from 'entities';
import React from 'react';
// eslint-disable-next-line no-restricted-imports
import { OutdoorBarArticlePageMainPortionCard } from './OutdoorBarArticlePageMainPortionCard';

export type OutdoorBarArticlePageMainPortionPickerProps = {
    outdoorBarArticlePortions: OutdoorBarArticlePortionModel[]
} & GridProps & React.RefAttributes<HTMLDivElement>;

export const OutdoorBarArticlePageMainPortionPicker
: React.FC<OutdoorBarArticlePageMainPortionPickerProps> = ({
    outdoorBarArticlePortions,
    ...restProps
}) => (
    <Grid gap="2rem" {...restProps}>
        <Grid
            gap="2rem"
            width="100%"
        >
            {
                outdoorBarArticlePortions?.map(({
                    value,
                    meassure,
                    description,
                    weight,
                    price,
                    currency,
                }) => (
                    <OutdoorBarArticlePageMainPortionCard
                        width="100%"
                        value={value}
                        measure={meassure.toLocaleUpperCase()}
                        description={description}
                        weight={weight}
                        price={price}
                        currency={currency?.abbreviation}
                        isActive={false}
                    />
                ))
            }
        </Grid>

    </Grid>
);
